import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolvePoKName } from '../utils/domainUtils.js';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useLocalizedPath } from '../hooks/useLocalizedPath.jsx';
import { SIGNUP_URL } from '../constants.js';
import { PURPLE, RADII } from './sections/theme.js';
import { TrackedEvent } from '../utils/analytics.js';

export default function RecognizeAchievements() {
    const { t } = useTranslation();
    const { prices } = useLocalizedPath();

    return (
        <Box component="section" id="contact-us" sx={{ py: { xs: 3, md: 5 } }}>
            <Container maxWidth="lg">
                <Box
                    sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        borderRadius: '24px',
                        background: PURPLE,
                        px: { xs: 3.5, md: 6 },
                        py: { xs: 6, md: 8 },
                        boxShadow: '0 24px 60px -28px rgba(81,36,166,0.5)',
                    }}
                >
                    <Stack
                        spacing={2}
                        sx={{
                            alignItems: 'center',
                            position: 'relative',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            component="h2"
                            sx={{
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: { xs: '1.6rem', md: '2.25rem' },
                                lineHeight: 1.15,
                                letterSpacing: '-0.01em',
                                maxWidth: 720,
                            }}
                        >
                            {t('commons.recognizeAchievements.title', { POK_NAME: resolvePoKName() })}
                        </Typography>
                        <Typography
                            sx={{
                                color: 'rgba(255,255,255,0.85)',
                                fontSize: { xs: 15, md: 17 },
                                fontWeight: 400,
                                lineHeight: 1.6,
                                maxWidth: 600,
                            }}
                        >
                            {t('commons.recognizeAchievements.subtitle')}
                        </Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 1 }}>
                            <Button
                                component="a"
                                href={SIGNUP_URL}
                                data-track={TrackedEvent.START_REGISTRATION}
                                target="_blank"
                                variant="contained"
                                sx={{
                                    background: '#fff',
                                    color: PURPLE,
                                    px: 3.5,
                                    py: 1.5,
                                    borderRadius: RADII.sm,
                                    fontWeight: 700,
                                    fontSize: 16,
                                    textTransform: 'none',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                                    '&:hover': {
                                        background: '#f3eefb',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 12px 30px rgba(0,0,0,0.24)',
                                    },
                                }}
                            >
                                {t('home.hero_cta')}
                            </Button>
                            <Button
                                component="a"
                                href={`${prices()}#contact`}
                                data-track={TrackedEvent.SCHEDULE_DEMO}
                                variant="outlined"
                                sx={{
                                    color: '#fff',
                                    borderColor: 'rgba(255,255,255,0.6)',
                                    px: 3.5,
                                    py: 1.5,
                                    borderRadius: RADII.sm,
                                    fontWeight: 700,
                                    fontSize: 16,
                                    textTransform: 'none',
                                    '&:hover': { borderColor: '#fff', background: 'rgba(255,255,255,0.1)' },
                                }}
                            >
                                {t('commons.button.schedule_demo')}
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </Container>
        </Box>
    );
}
